import * as signalR from '@microsoft/signalr';

let connection = null;
let startingPromise = null;

export const createAppConnection = async () => {
  if (connection && connection.state === signalR.HubConnectionState.Connected) {
    return connection;
  }

  if (startingPromise) {
    return startingPromise;
  }

  if (!connection) {
    const rawBaseUrl =
      process.env.REACT_APP_API_BASE_URL || 'http://localhost:6203';

    const baseUrl = rawBaseUrl.replace(/\/+$/, '');

    connection = new signalR.HubConnectionBuilder()
      .withUrl(`${baseUrl}/appHub`, {
        withCredentials: true,
      })
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.Information)
      .build();

    connection.onreconnecting((err) => {
      console.log('SignalR reconnecting...', err);
    });

    connection.onreconnected(() => {
      console.log('SignalR reconnected');
    });

    connection.onclose((err) => {
      console.log('SignalR closed', err);
    });
  }

  if (connection.state === signalR.HubConnectionState.Disconnected) {
    startingPromise = connection
      .start()
      .then(() => {
        console.log('SignalR Connected');
        return connection;
      })
      .catch((err) => {
        console.error('SignalR Connection Error:', err);
        throw err;
      })
      .finally(() => {
        startingPromise = null;
      });

    return startingPromise;
  }

  return connection;
};

export const joinModuleGroup = async (module, vendorId, branchId) => {
  const conn = await createAppConnection();
  await conn.invoke(
    'JoinVendorBranchGroup',
    String(module),
    String(vendorId || 0),
    String(branchId || 0),
  );
};

export const leaveModuleGroup = async (module, vendorId, branchId) => {
  if (!connection) return;

  if (connection.state !== signalR.HubConnectionState.Connected) return;

  await connection.invoke(
    'LeaveVendorBranchGroup',
    String(module),
    String(vendorId || 0),
    String(branchId || 0),
  );
};

export const subscribeRealtimeUpdate = async (callback) => {
  const conn = await createAppConnection();
  conn.on('ReceiveRealtimeUpdate', callback);
};

export const unsubscribeRealtimeUpdate = () => {
  if (!connection) return;
  connection.off('ReceiveRealtimeUpdate');
};

export const getAppConnection = () => connection;
//
// import * as signalR from '@microsoft/signalr';

// let connection = null;
// let currentHandler = null;

// export const createAppConnection = async () => {
//   if (connection) return connection;

//   connection = new signalR.HubConnectionBuilder()
//     .withUrl('/apphub')
//     .withAutomaticReconnect()
//     .build();

//   await connection.start();
//   return connection;
// };

// export const joinModuleGroup = async (module) => {
//   if (!connection) await createAppConnection();
//   await connection.invoke('JoinModuleGroup', module);
// };

// export const leaveModuleGroup = async (module) => {
//   if (!connection) return;
//   await connection.invoke('LeaveModuleGroup', module);
// };

// export const subscribeRealtimeUpdate = async (callback) => {
//   if (!connection) await createAppConnection();

//   if (currentHandler) {
//     connection.off('ReceiveRealtimeUpdate', currentHandler);
//   }

//   currentHandler = (payload) => {
//     callback?.(payload);
//   };

//   connection.on('ReceiveRealtimeUpdate', currentHandler);
// };

// export const unsubscribeRealtimeUpdate = () => {
//   if (!connection || !currentHandler) return;
//   connection.off('ReceiveRealtimeUpdate', currentHandler);
//   currentHandler = null;
// };
